import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconFormatItalicComponent } from "./med-icon-format-italic.component";

@NgModule({
  declarations: [
    MedIconFormatItalicComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconFormatItalicComponent,
  ],
})
export class MedIconFormatItalicModule { }
